var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj['document-card'] = true, _obj['disabled'] = _vm.isDisabled, _obj['empty'] = _vm.isEmpty, _obj )},[(!_vm.isEmpty)?_vm._t("default",function(){return [_c('InlineLoader')]},{"emitEvent":_vm.emitEvent}):_vm._t("default",null,{"emitEvent":_vm.emitEvent})],2)}
var staticRenderFns = []

export { render, staticRenderFns }